import React, { Component } from 'react';
import './Comments.css';
import moment from 'moment';
import Avatar from 'react-avatar';
class Comments extends Component {
  constructor(props) {
    super(props);
    var newComments = [];
    if (props.formData !== undefined) {
      newComments = [...props.formData, {}];
    } else {
      newComments = [{ body: '' }];
    }

    this.state = {
      message: '',
      comments: newComments,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.formData !== undefined) {
      var newComments = [...nextProps.formData];
      this.setState({
        comments: newComments,
      });
    } else {
      var newComments = [{ body: '' }];
      this.setState({
        comments: newComments,
      });
    }
  }

  messageChangeHandler = (event) => {
    var newComments = [...this.state.comments];

    newComments[newComments.length - 1] = {
      ...newComments[newComments.length - 1],
      body: event.target.value,
    };

    this.props.onChange(newComments);

    this.setState({ message: event.target.value, comments: newComments });
  };

  formatDate = (date) => {
    moment.locale('es');
    return moment(date).format('LLLL');
  };

  render() {
    const { textareaLabel } = this.props;
    const { comments } = this.state;

    let message = (comments, comment, index) => {
      if (comments.length > index + 1) {
        return (
          <li key={index}>
            <div className="sl-comments-avatar">
              <Avatar name={comment.userId} size="60" round={true} />
            </div>
            <div className="sl-comments-info">
              <h4 className="title">{comment.userName}</h4>
              <div className="date">{this.formatDate(comment.datetime)}</div>
              <div className="message">{comment.body}</div>
            </div>
          </li>
        );
      }
    };

    return (
      <div>
        <ul className="sl-comments-list">
          {comments.map((comment, index) => message(comments, comment, index))}
        </ul>

        <div className="form-group">
          <label htmlFor="commentsInput">
            {textareaLabel ? textareaLabel : 'Mensaje'}
          </label>
          <textarea
            id="commentsInput"
            className="form-control"
            rows="3"
            value={this.state.message}
            onChange={this.messageChangeHandler}
            required
          />
        </div>
      </div>
    );
  }
}

export default Comments;



// WEBPACK FOOTER //
// ./src/lib/Comments/Comments.jsx